import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import SessionService from "../Services/SessionService";
import { useBrokenLinkDialog } from "../Context/BrokenLinkDialogContext";
import React from "react";

interface BrokenLinkDialogProps {
  shareholderId?: any;
  currentFiscalYearId?: any;
  visible?: boolean;
  header?: string;
  message?: string;
  subject?: string;
  showSupportButton?: boolean;
  showHomeButton?: boolean;
  onRedirect?: () => void;
}

const BrokenLinkDialog = ({
  shareholderId,
  currentFiscalYearId,
  visible: visibleProp,
  header = "Something went wrong",
  message = "We can not find the profile you are looking for. If you need assistance, please request support.",
  subject = "Nexus: unable to load Profile",
  showSupportButton = true,
  showHomeButton = true,
  onRedirect,
}: BrokenLinkDialogProps) => {
  const role = SessionService.getRole();
  const { visible: visibleCtx, hideDialog } = useBrokenLinkDialog();
  const visible = typeof visibleProp === "boolean" ? visibleProp : visibleCtx;

  React.useEffect(() => {
    const mainContain = document.querySelector(
      ".main-contain"
    ) as HTMLElement | null;
    if (mainContain) {
      mainContain.style.visibility = visible ? "hidden" : "";
    }
    return () => {
      if (mainContain) mainContain.style.visibility = "";
    };
  }, [visible]);

  const handleSupportClick = () => {
    SessionService.clearSHId();
    const body =
      shareholderId && currentFiscalYearId
        ? `Shareholder ID: ${shareholderId}\nFiscalYear ID: ${currentFiscalYearId}`
        : "";
    const mailtoLink =
      "mailto:help@lbmc.com" +
      "?cc=DigitalProductTeam@lbmc.com" +
      "&subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(body);
    window.location.href = mailtoLink;
  };

  const handleReturnHome = () => {
    if (onRedirect) {
      onRedirect();
    } else {
      hideDialog();
      window.location.href = "/";
    }
  };

  return (
    <Dialog
      header={header}
      visible={visible}
      onHide={() => {
        if (onRedirect) onRedirect();
        else hideDialog();
      }}
      className="error-dialog"
      style={{ width: "520px" }}
      closable={false}
    >
      <div className="p-mb">
        <p className="text-lg font-medium mt-0">{message}</p>
      </div>

      <div className="flex justify-content-end mt-4">
        {showSupportButton && (
          <Button
            outlined
            label="Request Support"
            className="rounded mr-2"
            onClick={handleSupportClick}
          />
        )}

        {showHomeButton && (
          <Button
            label="Return to Home"
            className="rounded"
            onClick={handleReturnHome}
          />
        )}
      </div>
    </Dialog>
  );
};

export default BrokenLinkDialog;
